<svg
  [attr.viewBox]="store.getViewBoxString$() | async"
  preserveAspectRatio="xMinYMin meet"
>
  <foreignObject
    [attr.width]="store('sensorRendererState')('width').$ | async"
    [attr.height]="store('sensorRendererState')('height').$ | async"
  >
    <div xmlns="http://www.w3.org/1999/xhtml">
      <canvas *ngIf="imageOverlayData$ | async" #canvas></canvas>
    </div>
  </foreignObject>
</svg>
